import { style } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const sectionHeaderStyles = style({
  display: "grid",
  gap: vars.space["2xs"],
});
